import Vue from 'vue';
import Vuex from 'vuex';
import { getAuth } from "firebase/auth";
import { getFirestore, doc, getDoc, collection, getDocs, addDoc, updateDoc, deleteDoc } from "firebase/firestore";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: null,
    role: null,
    availability: [],
    reservations: [],
    userReservations: []
  },
  getters: {
    getUser(state) {
      return state.user;
    },
    getRole(state) {
      return state.role;
    },
    getAvailability(state) {
      return state.availability;
    },
    getReservations(state) {
      return state.reservations;
    },
    getUserReservations(state) {
      return state.userReservations;
    }
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    setRole(state, role) {
      state.role = role;
    },
    setAvailability(state, availability) {
      state.availability = availability;
    },
    setReservations(state, reservations) {
      state.reservations = reservations;
    },
    setUserReservations(state, userReservations) {
      state.userReservations = userReservations;
    },
    logout(state) {
      state.user = null;
      state.role = null;
      localStorage.removeItem('vuex'); // Clear local storage
    }
  },
  actions: {
    async fetchUser({ commit }) {
      const auth = getAuth();
      const db = getFirestore();
      const currentUser = auth.currentUser;

      if (currentUser) {
        const docRef = doc(db, "users", currentUser.uid);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const userData = docSnap.data();
          const user = {
            uid: currentUser.uid,
            firstName: userData.firstName,
            lastName: userData.lastName,
            email: currentUser.email,
          };
          commit("setUser", user);
          commit("setRole", userData.title); // Assuming 'title' contains the role (coach, advisor, user)
        }
      }
    },

    // Fetch all availability regardless of role
    async fetchAllAvailability({ commit }) {
      const db = getFirestore();
      const querySnapshot = await getDocs(collection(db, "availability"));
      const availability = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      commit('setAvailability', availability);  // Store all availability
    },

    async bookSlot({ dispatch }, { userId, slotId, reservedByName }) {
      const db = getFirestore();
      await updateDoc(doc(db, "availability", slotId), { isReserved: true, reservedBy: userId, reservedByName });
      dispatch('fetchAllAvailability');
    },

    async cancelReservation({ dispatch }, { userId, slotId }) {
      const db = getFirestore();
      await updateDoc(doc(db, "availability", slotId), { isReserved: false, reservedBy: null, reservedByName: null });
      dispatch('fetchAllAvailability');
    },

    async fetchReservations({ commit }, coachId) {
      const db = getFirestore();
      const querySnapshot = await getDocs(collection(db, "reservations"));
      const reservations = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      commit('setReservations', reservations.filter(res => res.coachId === coachId));
    },

    async fetchUserReservations({ commit }, userId) {
      const db = getFirestore();
      const querySnapshot = await getDocs(collection(db, "reservations"));
      const userReservations = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      commit('setUserReservations', userReservations.filter(res => res.userId === userId));
    },

    async createAvailability({ dispatch }, payload) {
      const db = getFirestore();
      await addDoc(collection(db, "availability"), payload);
      dispatch('fetchAllAvailability');
    },

    async updateAvailability({ dispatch }, { coachId, docId, newTimeSlot }) {
      if (!docId) {
        console.error("Document ID is undefined");
        return;
      }

      const db = getFirestore();
      const docRef = doc(db, "availability", docId);
      await updateDoc(docRef, newTimeSlot);
      dispatch('fetchAllAvailability');
    },

    async cancelAvailability({ dispatch }, { coachId, docId }) {
      const db = getFirestore();
      await deleteDoc(doc(db, "availability", docId));
      dispatch('fetchAllAvailability');
    }
  },
});